import config from "../config/config.json";

const StripeConfig =
  config.apiKeys.stripe[config.apiKeys.stripe.useSandbox ? "test" : "prod"];
const StripeAuthBaseUrl =
  "https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write";

export function getStripeConnectAuthUrl() {
  const redirectUri = `${StripeConfig.baseUrl}/connect/stripe`;
  return `${StripeAuthBaseUrl}&client_id=${StripeConfig.clientId}&redirect_uri=${redirectUri}`;
}
